// Phase 8 R1 — list active canned jobs for a shop with line counts.
// Phase 8 R4 — adds favorite fields + 60s staleTime for instant reopens.

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CannedJobListItem {
  id: string;
  name: string;
  description: string | null;
  category: string | null;
  line_count: number;
  is_favorite: boolean;
  favorite_order: number;
}

export function useCannedJobs(
  shopId: string | undefined,
  opts?: { search?: string; category?: string | null },
) {
  const search = opts?.search?.trim() ?? '';
  const category = opts?.category ?? null;

  return useQuery({
    queryKey: ['canned-jobs', shopId, search, category],
    enabled: !!shopId,
    staleTime: 60_000,
    queryFn: async (): Promise<CannedJobListItem[]> => {
      let q = (supabase as any)
        .from('canned_jobs')
        .select(
          'id, name, description, category, is_favorite, favorite_order, canned_job_lines(count)',
        )
        .eq('shop_id', shopId)
        .eq('is_active', true)
        .order('name', { ascending: true });

      if (search) {
        q = q.ilike('name', `%${search}%`);
      }
      if (category) {
        q = q.eq('category', category);
      }

      const { data, error } = await q;
      if (error) throw error;

      return (data ?? []).map((r: any) => ({
        id: r.id,
        name: r.name,
        description: r.description ?? null,
        category: r.category ?? null,
        is_favorite: !!r.is_favorite,
        favorite_order: Number(r.favorite_order ?? 0),
        line_count: Array.isArray(r.canned_job_lines)
          ? Number(r.canned_job_lines[0]?.count ?? 0)
          : 0,
      }));
    },
  });
}
